export const CREATE_WHATSAPP_CUSTOMER  = 'CREATE_WHATSAPP_CUSTOMER';
export const GET_WHATSAPP_CUSTOMER_CHECK  = 'GET_WHATSAPP_CUSTOMER_CHECK';
export const WHATSAPP_CUSTOMER_REQUEST  = 'WHATSAPP_CUSTOMER_REQUEST';
export const DELETE_WHATSAPP_CUSTOMER  = 'DELETE_WHATSAPP_CUSTOMER';
export const UPDATE_WHATSAPP_CUSTOMER  = 'UPDATE_WHATSAPP_CUSTOMER';
export const WHATSAPP_CUSTOMER_REQUEST_SUCCESS = 'WHATSAPP_CUSTOMER_REQUEST_SUCCESS';
export const WHATSAPP_CUSTOMER_REQUEST_FAILURE  = 'WHATSAPP_CUSTOMER_REQUEST_FAILURE';
export const GET_WHATSAPP_CUSTOMER_DETAIL  = 'GET_WHATSAPP_CUSTOMER_DETAIL';
